import * as tslib_1 from "tslib";
import { of, BehaviorSubject, Subject, ReplaySubject } from 'rxjs';
var ThemeService = /** @class */ (function () {
    function ThemeService() {
        this._themeId = new ReplaySubject(1);
        this.themeId$ = this._themeId.asObservable();
    }
    return ThemeService;
}());
export { ThemeService };
var FakeThemeService = /** @class */ (function (_super) {
    tslib_1.__extends(FakeThemeService, _super);
    function FakeThemeService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loaded = new BehaviorSubject(true);
        _this.changes = new Subject();
        return _this;
    }
    FakeThemeService.prototype.getTheme = function () {
        return of({ themeId: "theme" });
    };
    FakeThemeService.prototype.verifyTheme = function (clientId) {
        return of(true);
    };
    FakeThemeService.prototype.setTheme = function (themeId) {
        this._themeId.next(themeId);
    };
    FakeThemeService.prototype.reset = function () {
        this.loaded.next(false);
    };
    FakeThemeService.prototype.complete = function () {
        this.loaded.next(true);
    };
    return FakeThemeService;
}(ThemeService));
export { FakeThemeService };
